// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonUnits = {
  question: "题",
  score: "分",
  minutes: "分钟",
} as const;
